import { render, staticRenderFns } from "./ExampleComponent.vue?vue&type=template&id=f94aecb0&"
import script from "./ExampleComponent.vue?vue&type=script&lang=js&"
export * from "./ExampleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports